import React from 'react';
import PropTypes from 'prop-types';

// Demo styles, see 'Styles' section below for some notes on use.
//import 'react-accessible-accordion/dist/minimal-example.css';

class PrepaidRefills extends React.Component {

    render() {
        const { subscription } = this.props;

        return (
            <div style={{ padding: '10px' }}>
                {subscription && subscription.Refills && subscription.Refills.length > 0 &&
                    <table style={{ width: '100%', borderBottom: '1px solid rgba(0, 0, 0, 0.12)', fontSize: '1rem' }} cellSpacing="0" cellPadding="0">
                        <tbody>
                            <tr>
                                <th style={{ width: '50%', textAlign: 'left', fontSize: '12px' }}>Beskrivelse</th>
                                <th style={{ width: '30%', textAlign: 'left', fontSize: '12px' }}>Dato</th>
                                <th style={{ textAlign: 'right', fontSize: '12px' }}>Beløp</th>
                            </tr>
                            {subscription && subscription.Refills && subscription.Refills.map(function (refill, index) {
                                return (
                                    <tr key={index}>
                                        <td style={{ borderTop: '1px solid rgba(0, 0, 0, 0.12)', padding: '10px 0px' }}>{refill.Description}</td>
                                        <td style={{ borderTop: '1px solid rgba(0, 0, 0, 0.12)', padding: '10px 0px' }}>{refill.Date}</td>
                                        <td style={{ borderTop: '1px solid rgba(0, 0, 0, 0.12)', padding: '10px 0px', textAlign: 'right' }}>{refill.Amount}</td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>}
            </div>
        );
    }
}

PrepaidRefills.propTypes = {
    subscription: PropTypes.object,
};

export default PrepaidRefills;
